export const environment = {
  production: false,
  title:"Development",
  firebase: {
    apiKey: "AIzaSyA5poMvcBPX902q3youLBgz0vj-dYy8Bek",
    authDomain: "ole-forms-module.firebaseapp.com",
    projectId: "ole-forms-module",
    storageBucket: "ole-forms-module.appspot.com",
    messagingSenderId: "916517917076",
    appId: "1:916517917076:web:9c467e2a9978f028dd3f81",
    measurementId: "G-80BY52JN9F"
  },
  appTitle: 'OLÉ (dev)',
  // api: "http://localhost:5000/ole-forms-module/us-central1/api-v1" // Local
  api: "https://us-central1-ole-forms-module.cloudfunctions.net/api-v1" // Dev
  // api: "https://us-central1-ole-qms-qa.cloudfunctions.net/api-v1" // Test
  // api: "https://us-central1-ole-qms-prod.cloudfunctions.net/api-v1" // Producción
};

/*
 * https://us-central1-ole-forms-module.cloudfunctions.net/api-v1
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
